import axios from "axios";

class LeaderboardService {
    getLeaderboard(data) {
        return axios.post("/leaderboard/getAll", data);
    }

    createNewLeaderboardIntake(data) {
        return axios.post("/leaderboard/createNewLeaderboardIntake", data);
    }

    generateLeaderboard() {
        return axios.get("/leaderboard/generate");
    }

    removeLeaderboard(id) {
        return axios.delete(`/leaderboard/remove/${id}`);
    }
}

export default new LeaderboardService();